import React from "react";
import './UseCasesApplicationsComponent.scss';
import { ProductItemComponentProps } from "../../constants/interface.ts";
import { useTranslation } from "react-i18next";
import IconCardComponent from "../IconCardComponent/IconCardComponent.tsx";

const UseCasesApplicationsComponent = (props: ProductItemComponentProps) => {
    const { title = '', paragraph = '', img = '', list = [], } = props;
    const {t} = useTranslation();

    return (
        <div className="flex flex-col gap-8 lg:gap-16">
            <div className="flex flex-col gap-5">
                <p className="text-3xl font-semibold text-black-1A1 lg:text-4xl">{t(title)}</p>
                <>
                {
                    (paragraph) &&
                    <p className="text-base font-normal text-gray-535 lg:text-xl lg:max-w-[40rem]">{t(paragraph)}</p>
                }
                </>
            </div>
            <>
                {
                    list?.map((item, index: number) => (
                        <div key={index} className={`flex flex-col gap-16 lg:gap-10 lg:items-center lg:${(index % 2 === 0) ? 'flex-row' : 'flex-row-reverse'}`}>
                            <div className="lg:w-1/2">
                                <IconCardComponent
                                    img={''}
                                    imgContainerClass={'bg-white border border-gray-E9E'}
                                    title={item.title || ''}
                                    titleClass={'text-black-1A1'}
                                    paragraph={item.paragraph || ''}
                                    paragraphClass={'text-gray-535'}
                                    index={index}
                                    list={item.list || []}
                                />
                            </div>
                            <div
                                className="relative bg-cover w-full h-[23.125rem] rounded-md bg-gray-DDE lg:h-auto lg:rounded-lg lg:w-1/2 lg:min-h-[28.5rem]"
                                style={{ backgroundImage: `url('${item.img}')`}}
                            ></div>
                        </div>
                    ))
                }
            </>
        </div>
    );
};

export default UseCasesApplicationsComponent;